// src/services/publicApi.js
import axios from "axios";

const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== "/api"
        ? process.env.REACT_APP_API_URL
        : "http://localhost:5001/api")
    : (process.env.REACT_APP_API_URL || "/api");

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const publicAPI = {
  // 1. Daily Current Affairs (Only published items)
  getDailyCA: async (params = {}) => {
    const res = await api.get("/public/current-affairs/daily", { params });
    return res.data;
  },

  // 2. Monthly Current Affairs (Only published items)
  getMonthlyCA: async (params = {}) => {
    const res = await api.get("/public/current-affairs/monthly", { params });
    return res.data;
  },

  // 3. Prelims Initiatives
  // Today's Test Only (Strict IST date match)
  getPrelimsToday: async () => {
    const res = await api.get("/public/prelims/today");
    return res.data;
  },

  // All published tests (for historical or drill practice)
  getPrelimsTests: async (params = {}) => {
    const res = await api.get("/public/initiatives/prelims", { params });
    return res.data;
  },

  getPrelimsTestById: async (id) => {
    const res = await api.get(`/public/initiatives/prelims/${id}`);
    return res.data;
  },

  // 4. Mains Initiatives (Only published and non-expired initiatives)
  getMainsInitiatives: async (params = {}) => {
    const res = await api.get("/public/mains/initiatives", { params });
    return res.data;
  },

  getMainsInitiativeById: async (id) => {
    const res = await api.get(`/public/initiatives/mains/${id}`);
    return res.data;
  },
};

export const resolvePublicAssetUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  const host = API_BASE_URL.replace(/\/api$/, "");
  return `${host}${url.startsWith("/") ? "" : "/"}${url}`;
};

export default publicAPI;
